import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { CometStar } from './BrandArtwork';
import { HeroBackgroundVideo } from './HeroBackgroundVideo';
import { principles } from '../data/site';
export function Hero() {
  return <section id="top" className="bg-ink" data-id="element-49" data-mp="9lbhp5hdljfp">
      <div className="relative min-h-[780px] overflow-hidden md:min-h-[640px] lg:min-h-[700px]" data-id="element-50" data-mp="4lqjwydxzh4k">
        <HeroBackgroundVideo data-id="element-51" data-mp="129h21r4ip6f0" />

        <div className="relative z-10 mx-auto flex min-h-[780px] max-w-content flex-col justify-start px-5 pb-24 pt-14 sm:px-6 md:min-h-[640px] md:justify-center md:px-8 md:py-24 lg:min-h-[700px] lg:px-10" data-id="element-52" data-mp="129qvjoortvpg">
          <div className="max-w-[650px]" data-id="element-53" data-mp="sa9rtct2xrw4">
            <p className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.22em] text-cream/70" data-id="element-54" data-mp="sddz4j1ud3r0">
              <CometStar className="h-2.5 w-2.5 text-gold" data-id="element-55" data-mp="3d1ihv20l0yjq" />
              Independent app studio
            </p>

            <h1 className="mt-7 font-display text-[40px] font-semibold leading-[1.04] tracking-[-0.025em] text-cream sm:text-[56px] lg:text-[66px]" data-id="element-56" data-mp="381xkgw128y94">
              Apps with purpose.
              <br data-id="element-57" data-mp="3o7lvm11r3otp" />
              <span className="text-violet" data-id="element-58" data-mp="3o858328mtl0c">
                Built with care
                <span className="text-gold" data-id="element-59" data-mp="39acuifmnb6os">.</span>
              </span>
            </h1>

            <p className="mt-7 max-w-lg text-[17px] leading-relaxed text-cream/80" data-id="element-60" data-mp="39cpfz2rm3z6l">
              Thoughtful apps for learning, everyday life and play — built for U.S. users, with
              quality and feedback at the center.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-6" data-id="element-61" data-mp="359syxghq0b4r">
              <a href="#lab" className="inline-flex min-h-[52px] items-center gap-2 rounded-[2px] bg-violet px-7 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-violet/85" data-id="element-62" data-mp="2qk3i6cx59yjd">
                Explore the lab
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-63" data-mp="2lkqx9xpu31jf" />
              </a>
              <a href="#story" className="inline-flex min-h-[44px] items-center border-b border-cream/40 text-[15px] font-medium text-cream/90 transition-colors duration-150 ease-out hover:border-cream hover:text-cream" data-id="element-64" data-mp="2lmld4xm903gn">
                Our story
              </a>
            </div>
          </div>

          <p className="mt-auto flex max-w-sm items-start gap-2 pt-16 text-[12px] leading-relaxed text-cream/60 md:absolute md:bottom-8 md:left-8 md:mt-0 md:max-w-xs md:pr-20 md:pt-0 lg:left-10" data-id="element-65" data-mp="de6munocvvj7">
            <CometStar className="mt-1 h-2.5 w-2.5 shrink-0 text-gold" data-id="element-66" data-mp="162ued0zp7h57" />
            Named in memory of the founder&rsquo;s black cat. The gold star is his comet tail.
          </p>
        </div>
      </div>

      <div className="border-t border-cream/15" data-id="element-67" data-mp="x0crckc7ykh5">
        <dl className="mx-auto grid max-w-content grid-cols-1 gap-px bg-cream/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-68" data-mp="3lsysoz5l2mj2">
          {principles.map(principle => <div key={principle.title} className="bg-ink px-5 py-9 md:px-8 lg:px-10" data-id="element-69" data-mp="3hpsdv34enn0z">
              <dt className="font-display text-[26px] font-medium leading-none text-cream md:text-[30px]" data-id="element-70" data-mp="1xacj1d51o1xz">
                {principle.title}
              </dt>
              <dd className="mt-3 text-[14px] leading-relaxed text-cream/60" data-id="element-71" data-mp="26a9a1lewpcw7">{principle.caption}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}